<template>
    <div>
        <v-col cols="4" md="4">
            <v-select
                v-model="region"
                :items="getAllRegions()"
                item-text="value"
                item-value="key"
                label="Województwo"
            >

            </v-select>
        </v-col>
        <v-col cols="2" md="2">
            <v-text-field v-model="distance" label="Odległość od oddziału"></v-text-field>
            <v-btn @click="load">Filtruj</v-btn>
        </v-col>
        <v-sheet class="pa-4 blue-grey lighten-1">
            <v-text-field
                v-model="search"
                label="Odfiltruj po fragmencie nazwy..."
                dark
                flat
                solo-inverted
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
            />
            <v-checkbox
                v-model="caseSensitive"
                dark
                hide-details
                label="Uwzględniaj wielkość znaków"
            />
            <v-btn @click="selectAll" class="mt-2 mr-2">Zaznacz wszystkie</v-btn>
            <v-btn @click="unselectAll" class="mt-2">Odznacz wszystkie</v-btn>
        </v-sheet>
        <v-form>
            <v-treeview
                selectable
                :items="cityTree"
                item-children="cities"
                selection-type="independent"
                :value="selectedIds"
                :search="search"
                :filter="filter"
                @update:open="onNodeOpenClose"
                @input="onCheckboxChanged"
            />
        </v-form>
        <div>
            <v-btn
                @click="save()"
            >
                Zapisz&nbsp;
                <v-icon size="24" right>
                    mdi-content-save-outline
                </v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import api from "@/services/api";
import filters from "@/mixins/filters";
import {mapGetters} from "vuex";

export default {
    props: {
        reloadCompanyBranchData: {},
        companyId: {
            type: [String],
            required: true,
        },
        excluded: {
            type: [Boolean],
            required: true,
        },
        branchId: {
            type: [String],
            required: true,
        }
    },
    mixins: [
        filters,
    ],
    components: {},
    data() {
        return {
            loading: false,
            isDirty: false,
            loggingEnabled: false,
            options: {},
            filters: {},
            region: null,
            distance: null,
            // Multi-dimensional array of objects. Contains city data (id and name) and information
            // which one system city is subscribed by this company branch and which one not.
            subscriptionData: [],

            // Multi-dimensional city tree. For displaying purposes.
            cityTree: [],

            // Flat, associative array of objects. For easier management.
            cityArrayObject: {},

            // Ids of selected cities. TreeView will use this array to select checkboxes on initial render.
            selectedIds: [],

            search: null,
            caseSensitive: false,
            loadedCities: [],
        };
    },
    created() {

    },
    mounted() {
        this.load();
    },
    computed: {
        filter() {
            return this.caseSensitive
                ? (item, search, textKey) => item[textKey].indexOf(search) > -1
                : undefined;
        },
    },
    methods: {
        ...mapGetters(['getAllRegions']),
        getSelectedIds() {
            const nodesArrayObject = this.getTreeViewNodeArrayObject();
            const properties = Object.getOwnPropertyNames(nodesArrayObject);
            let ids = [], property, id, data;

            for (let i = 0; i < properties.length; i++) {
                property = properties[i];
                id = parseInt(property, 10);

                if (!id) {
                    continue; // Not a node property, skip it.
                }

                data = nodesArrayObject[id];

                if (!data.isSelected) {
                    continue;
                }

                ids.push(id);
            }

            return ids;
        },
        getSubscriptionInfo() {
            const nodesArrayObject = this.getTreeViewNodeArrayObject();
            const properties = Object.getOwnPropertyNames(nodesArrayObject);
            let infoArray = [], property, id, data;

            for (let i = 0; i < properties.length; i++) {
                property = properties[i];
                id = parseInt(property, 10);

                if (!id) {
                    continue; // Not a node property, skip it.
                }

                data = nodesArrayObject[id];

                infoArray.push({
                    id: id,
                    isSubscribed: data.isSelected,
                    excluded: this.excluded
                });
            }

            return infoArray;
        },
        getFormComponent() {
            let $form = null;

            this.$children.some(($component) => {
                const $node = $component.$el;

                if ($node && 'FORM' === $node.tagName) {
                    $form = $component;

                    return true;
                }
            });

            if ($form) {
                return $form;
            }

            throw new Error('Unable to find the <form>!');
        },
        getTreeViewNodeArrayObject() {
            const $form = this.getFormComponent();
            const $treeView = $form.$children[0];
            const arrayObject = $treeView.nodes; // One dimensional, associative array of objects!

            if (!arrayObject) {
                return {}; // Return dummy object to avoid accessing wrong reference.
            }

            return arrayObject;
        },
        load(options = {}) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            options = options || {};

            let query = '?excluded=' + this.excluded;

            if (this.region) {
                query += '&region=' + this.region;
            }

            if (this.distance) {
                query += '&distance=' + this.distance;
            }

            api.get(`/api/price-list/company-branch-city/${this.branchId}${query}`)
                .then((response) => {
                    this.subscriptionData = response.data.tree;
                    this.updateCityTree();

                    if (options.onSuccess) {
                        options.onSuccess();
                    }
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się wczytać miast.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        refresh() {
            this.load();
        },
        save() {
            if (!this.isDirty) {
                return new Promise((resolve) => {
                    resolve(true)
                })
            }

            this.loading = true;
            const data = this.getSubscriptionInfo();
            const params = {
                cities: data,
            };

            console.log('Selected city IDs (will be sent to server):', this.getSelectedIds());

            api.put(`/api/price-list/company-branch-city/${this.branchId}?excluded=${this.excluded}`, params)
                .then((response) => {
                    this.subscriptionData = response.data.tree;
                    this.updateCityTree();
                    this.reloadCompanyBranchData();

                    this.$root.$emit("notifySuccess", {
                        html: "Miasta zostały zapisane.",
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zapisać miast.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onNodeOpenClose(openedIds) {
            console.log('onNodeOpenClose()!, openedIds:', openedIds);
        },
        onCheckboxChanged(selectedIds) {
            console.log('Selected city IDs (from event):', selectedIds);
            console.log('Selected city IDs (from traversal):', this.getSelectedIds());
            this.isDirty = true;
        },
        selectAll() {
            this.loadedCities.forEach(city => {
                if (!this.selectedIds.includes(city)) {
                    this.selectedIds.push(city);
                }
            });
        },
        unselectAll() {
            this.loadedCities.forEach(city => {
                const index = this.selectedIds.indexOf(city);
                if (index !== -1) {
                    this.selectedIds.splice(index, 1);
                }
            });
        },
        updateCityTree() {
            this.cityArrayObject = {};
            this.updateCityArrayObject(
                this.cityArrayObject,
                this.subscriptionData,
                null
            );

            this.cityTree.length = 0; // Trick to empty the array without changing the reference!

            for (const data of this.subscriptionData) {
                this.cityTree.push(data);
            }

            this.selectedIds.length = 0; // Trick to empty the array without changing the reference!
            const properties = Object.getOwnPropertyNames(this.cityArrayObject);
            let property, data;

            this.loadedCities = [];
            for (let i = 0; i < properties.length; i++) {
                property = properties[i];
                data = this.cityArrayObject[property];
                this.loadedCities.push(data.id);
                if (data.isSubscribed) {
                    this.selectedIds.push(data.id);
                }
            }

            this.isDirty = false;

            console.log('Initially selected city IDs:', this.selectedIds);
        },
        updateCityArrayObject(arrayObject, cities) {
            if (!cities) {
                console.warn('There are no city data.');
            }

            cities.forEach((city) => {
                arrayObject[city.id] = {
                    id: city.id,
                    isSubscribed: city.isSubscribed,
                };
            })
        },
    },
}
</script>